<template>
  <div>
    <div class="flex-row keyword-input-wrap">
      <input v-model="newStr" v-on:keyup.enter="pushStr" :disabled="disabled" class="form-control" type="text" v-bind:placeholder="itemName">
      
      <input v-if="showDateField" v-model="newDate" v-on:keyup.enter="pushStr" :disabled="disabled" v-bind:class="dateHasError ? 'is-invalid form-control' : 'form-control'" type="date" placeholder="Start Date">
      
      <button @click.prevent="pushStr()" :disabled="disabled" class="btn btn-primary">Add {{itemName}}</button>
      
    </div>
    <ul class="keyword-list">
      <div v-for="singleStr in strListFiltered">
        <li>{{typeof singleStr == "string" ? singleStr : singleStr.str}} {{singleStr.startDate ? '(' + singleStr.startDate + ')' : ''}} <button :disabled="disabled" @click.prevent="removeStr(singleStr)" class="btn btn-danger">Remove {{itemName}}</button></li>
      </div>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      strList: {
        type: Array,
      },
      inclDate: {
        type: String
      },
      filterDate: {
        type: String
      },
      autoDate: {
        type: String
      },
      disabled: {
        type: Boolean
      },
      itemName: {
        type: String
      }
    },
    data: function() {
      return {
        newStr: '',
        newDate: '',
        dateHasError: false
      }
    },
    
    computed: {
      showDateField() {
        return this.autoDate===undefined &&
          this.inclDate && this.inclDate.toUpperCase()=='TRUE' &&
          (this.filterDate === undefined || this.filterDate.toUpperCase() === "ALL" || this.filterDate.toUpperCase() === "TRUE");
      },
      
      strListFiltered() {
        return this.strList.filter((str) => {
          if(!this.filterDate) {
            return true;
          }
          else if(this.filterDate.toUpperCase() == "TRUE") {
            if(typeof str == "string") {
              return true;
            }
            else {
              return !!str.startDate;
            }
          }
          else if(this.filterDate.toUpperCase() == "FALSE") {
            if(typeof str == "string") {
              return false;
            }
            else {
              return !str.startDate;
            }
          }
          else {
            return true;
          }
        });
      }
    },
    
    methods: {
      pushStr() {
        if(!this.hasStr(this.newStr) && this.newStr.length > 0) {
          if(this.showDateField) {
            if(this.newDate) {
              this.dateHasError = false;
              
              this.strList.push({
                str: this.newStr,
                startDate: this.newDate
              });
            }
            else {
              this.dateHasError = true;
              return;
            }
          }
          else {
            this.strList.push(this.newStr);
          }
          
          this.newStr = '';
          this.$emit('save-strs', this.normalizeList(this.strList));
        } else {
          return;
        }
      },
      
      removeStr(strCurrent) {
        this.strList.splice(this.strList.indexOf(strCurrent), 1)
      },
      
      normalizeList(strList) {
        for(var index=0; index<strList.length; index++) {
          const item = strList[index];
          
          if(this.inclDate && this.inclDate.toUpperCase() == "TRUE") {
            if(typeof item == "string") {
              strList[index] = {
                str: item,
                startDate: null
              }
            }
          }
          else {
            if(typeof item != "string") {
              strList[index] = item.str;
            }
          }
        }
        
        return strList;
      },
      
      hasStr(checkStr) {
        for(var index=0; index<this.strList.length; index++) {
          const item = this.strList[index];
          
          if(typeof item == "string") {
            if(item == checkStr) {
              return true;
            }
          }
          else {
            if(item.str == checkStr) {
              return true;
            }
          }
        }
        
        return false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AddStringList.vue